import { z } from 'zod'

import {
  PackageSourceSchema,
  TagDomainSelectModelSchema,
  TeamDomainQueryModelSchema,
} from '@mntn-dev/domain-types'
import { nonEmptyArraySchema } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const GetTeamsForBiddingInputSchema = z.object({
  tagIds: nonEmptyArraySchema(TagDomainSelectModelSchema.shape.tagId),
  packageSource: PackageSourceSchema,
})

export type GetTeamsForBiddingInput = ZodInfer<
  typeof GetTeamsForBiddingInputSchema
>

export const GetTeamsForBiddingOutputSchema =
  TeamDomainQueryModelSchema.required({ users: true }).array()

export type GetTeamsForBiddingOutput = ZodInfer<
  typeof GetTeamsForBiddingOutputSchema
>
